export const appointmentServiceTypesEndpoint = 'apptypes';
